<div class="file-previewer-host" [style.height]="height()">
  @switch (state()) {
    @case ('pdf') {
      <lib-pdf-viewer [src]="url()" [height]="height()" />
    }
    @case ('docx') {
      <lib-docx-viewer [src]="url()" [height]="height()" />
    }
    @case ('image') {
      <lib-img-viewer [src]="url()" [height]="height()" />
    }
    @case ('missing-url') {
      <div class="file-previewer-fallback">
        <i class="pi pi-exclamation-triangle file-previewer-fallback__icon"></i>
        <p class="file-previewer-fallback__message">No file available to preview.</p>
      </div>
    }
    @default {
      <div class="file-previewer-fallback">
        <i class="pi pi-eye-slash file-previewer-fallback__icon"></i>
        <p class="file-previewer-fallback__message">Preview is not available for this file type.</p>

        @if (hasUrl()) {
          <p-button label="Download" icon="pi pi-download" [loading]="isDownloading()" (onClick)="download()" />
        }
      </div>
    }
  }
</div>
